export default __webpack_public_path__ + "static/9_hard-light-7adbbde318afd2735d8fe66c6c3ab94e.png";